import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { DepartmentDto } from '../../dtos/department.dto';

@Injectable({ providedIn: 'root' })
export class DepartmentsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getDepartments(organizationId: number): Observable<DepartmentDto[]> {
    return this.http.get<DepartmentDto[]>(`${this.apiUrl}${API_ENDPOINTS.departments.list(organizationId)}`);
  }
}
